import type { FormSchemaFieldValue } from '#layers/block-engine/types/form-schema';
import { klona } from 'klona';
import { deepToRaw } from '#layers/base';
import { set } from '#layers/base/utils/object';

/**
 * Apply a field change without mutating the root object.
 */
export function setCopyValue<TValues extends object, TName extends string>(values: TValues, name: TName, value: FormSchemaFieldValue<TValues, TName>): TValues {
	if (!name.includes('.')) {
		return {
			...values,
			[name]: value,
		};
	}

	const [firstName, ...restNames] = name.split('.') as [string, ...string[]];
	// Clone the first path branch. Nested siblings inside that branch are copied
	// too, while unrelated root branches keep their object identity.
	const nextBranch = cloneBranch((values as Record<string, unknown>)[firstName]);

	set(nextBranch, restNames, value);

	return {
		...values,
		[firstName]: nextBranch,
	};
}

/**
 * Clone the first path branch that will be changed by the copy adapter.
 */
function cloneBranch(value: unknown): Record<string, unknown> {
	if (value && typeof value === 'object') {
		return klona(deepToRaw(value)) as Record<string, unknown>;
	}

	return {};
}
